import React from 'react';

import { LightDiskBadge } from 'apps/promo/components/common/fromAuth/LightDiskBadge/LightDiskBadge';
import { LightPanel } from 'apps/promo/components/common/fromAuth/LightPanel/LightPanel';

const PromoCountryLetterItem = (props) => {
    return (
        <LightPanel negativeMargin>
            <LightDiskBadge variant="letterIndex" diskText={props.letter} />
        </LightPanel>
    );
};

export default PromoCountryLetterItem;
